import React, { useState, useEffect, useRef } from "react";
import { Modal, Spin, message } from "antd";
import PropTypes from "prop-types";

const VendorAppModal = ({ isOpen, onCancel, vendorUrl, businessId, accessToken, refreshToken, userId, email}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Handle iframe load event
  const handleIframeLoad = () => {
    setLoading(false);
  };

  // Handle iframe load error
  const handleIframeError = () => {
    setLoading(false);
    setError("Failed to load vendor app. Please try again.");
  };

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      setError(null);
    }
  }, [isOpen]);
  // Use the redirectUrl directly if it's a complete URL, otherwise construct it
  const iframeSrc = accessToken && accessToken.startsWith('http')
    ? accessToken
    : `${vendorUrl}?businessId=${businessId}&userId=${userId}&email=${email}&adminAccess=true${accessToken ? `&accessToken=${accessToken}&refreshToken=${refreshToken}` : ''}`;
    console.log(iframeSrc, "vendorUrl", accessToken)

  return (
    <Modal
      title="Vendor App Supervison"
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      width="90%"
      style={{ top: 20 }}
      bodyStyle={{ height: "90vh", padding: "0" }}
    >
      {loading && (
        <div className="flex justify-center items-center h-full">
          <Spin size="large" tip="Loading vendor app..." />
        </div>
      )}
      {error && (
        <div className="flex justify-center items-center h-full text-red-500">
          {error}
        </div>
      )}
      {!error && (
        <iframe
          src={iframeSrc}
          title="Vendor App"
          className="w-full h-full border-0"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          style={{ display: loading ? "none" : "block" }}
        />
      )}
    </Modal>
  );
};

VendorAppModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  vendorUrl: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
  accessToken: PropTypes.string,
};

export default VendorAppModal;
